import { Box } from "@mui/material"
import React from "react"

export default function ActionButton({
  children,
  icon,
  variant = "primary",
}: {
  children: React.ReactNode
  icon?: React.ReactNode
  variant?: "primary" | "accent"
}) {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        alignItems: "center",
        gap: "0.625rem",
        padding: "0.6875rem 0.75rem",
        border: "1px solid",
        borderColor: theme.palette.borderPrimary,
        borderRadius: "0.375rem",
        color: variant === "primary" ? theme.palette.text.primary : theme.palette.accent.main,
        ":hover": {
          backgroundColor: theme.palette.titleBar,
        },
      })}
    >
      {icon}
      {children}
    </Box>
  )
}
